/**
 * SwatchLazyLoader - Module to lazy load color swatches using Intersection Observer
 * This improves page load performance by only loading swatch images when they become visible
 */
const SwatchLazyLoader = {
  init: function () {
    // Select all color swatches on the page
    const swatches = document.querySelectorAll(".color-swatch");

    // Exit early if there are no swatches or if IntersectionObserver is not supported
    if (!swatches.length || !("IntersectionObserver" in window)) {
      return;
    }

    // Create an observer that will watch for swatches entering the viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Check if the swatch is now visible (or about to be visible)
          if (entry.isIntersecting) {
            // Add the class that enables the background image via CSS
            entry.target.classList.add("swatch-loaded");
            // Stop observing this swatch since it's already loaded
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Start loading swatches when they're within 150px of the viewport
        rootMargin: "150px",
      }
    );

    // Start observing all swatches
    swatches.forEach((swatch) => {
      observer.observe(swatch);
    });
  },
};

// Initialize as soon as the DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", SwatchLazyLoader.init);
} else {
  SwatchLazyLoader.init();
}
